import React, { useState, useEffect } from 'react';

import cn from 'classnames';

import TriangleIcon from '../../TriangleIcon/TriangleIcon';

function TreeNode({ baseLevel, node, children, setShowElements }) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setShowElements((prevState) => {
      const nodeIsVisible = prevState.some((item) => node.id === item.id);
      setIsVisible(nodeIsVisible);
      return prevState;
    });
  }, [node.id, node.name, setShowElements]);

  const toggle = () => {
    if (children) {
      setShowElements((prevState) => {
        const nodeIsVisible = prevState.some((item) => node.id === item.id);
        if (nodeIsVisible) {
          setIsVisible(false);
          return prevState.filter((item) => item.id !== node.id);
        } else {
          setIsVisible(true);
          return [...prevState, node];
        }
      });
    }
  };

  return (
    <li
      className={cn({
        base_row: baseLevel && isVisible,
      })}
    >
      <div
        className={cn('table__tree__row', {
          hover: children,
          hidden_row: baseLevel && !isVisible,
        })}
      >
        <span onClick={toggle} className={cn('table__tree__label ', { 'table__tree__label-pointer': children })}>
          {node.name}
        </span>
        {children && (
          <button onClick={toggle}>
            <TriangleIcon direction={isVisible ? 'down' : 'right'} />
          </button>
        )}
      </div>
      {isVisible && children && (
        <ul>
          {children.map((i) => (
            <TreeNode key={i.id} node={i} children={i.children} setShowElements={setShowElements} />
          ))}
        </ul>
      )}
    </li>
  );
}

export default TreeNode;
